import React from "react";

class Review extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <section className="customer-review-section ptb-100 gray-light-bg">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-6 col-lg-6">
                <div className="testimonial-quote-wrap my-lg-3 my-md-3 rounded white-bg shadow-sm p-5">
                  <div className="client-say">
                    <p>
                      <img
                        src="img/quote.png"
                        alt="quote"
                        className="img-fluid"
                      />{" "}
                      Rapidiously develop user friendly growth strategies after
                      extensive initiatives. Conveniently grow innovative
                      benefits through fully tested deliverables. Rapidiously
                      utilize focused platforms through end-to-end schemas.
                    </p>
                  </div>
                  <div className="media author-info mb-3">
                    <div className="author-img mr-3">
                      <img
                        src="img/client-1.jpg"
                        alt="client"
                        className="img-fluid rounded-circle"
                      />
                    </div>
                    <div className="media-body">
                      <h5 className="mb-0">Arabella Orin</h5>
                      <span>Brinf LLC</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-sm-6 col-lg-6">
                <div className="testimonial-quote-wrap my-lg-3 my-md-3 rounded white-bg shadow-sm p-5">
                  <div className="client-say">
                    <p>
                      <img
                        src="img/quote.png"
                        alt="quote"
                        className="img-fluid"
                      />{" "}
                      Rapidiously develop user friendly growth strategies after
                      extensive initiatives. Conveniently grow innovative
                      benefits through fully tested deliverables. Rapidiously
                      utilize focused platforms through end-to-end schemas.
                    </p>
                  </div>
                  <div className="media author-info mb-3">
                    <div className="author-img mr-3">
                      <img
                        src="img/client-2.jpg"
                        alt="client"
                        className="img-fluid rounded-circle"
                      />
                    </div>
                    <div className="media-body">
                      <h5 className="mb-0">Runu Mondol</h5>
                      <span>BizBite</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-sm-6 col-lg-6">
                <div className="testimonial-quote-wrap my-lg-3 my-md-3 rounded white-bg shadow-sm p-5">
                  <div className="client-say">
                    <p>
                      <img
                        src="img/quote.png"
                        alt="quote"
                        className="img-fluid"
                      />{" "}
                      Rapidiously develop user friendly growth strategies after
                      extensive initiatives. Conveniently grow innovative
                      benefits through fully tested deliverables. Rapidiously
                      utilize focused platforms through end-to-end schemas.
                    </p>
                  </div>
                  <div className="media author-info mb-3">
                    <div className="author-img mr-3">
                      <img
                        src="img/client-3.jpg"
                        alt="client"
                        className="img-fluid rounded-circle"
                      />
                    </div>
                    <div className="media-body">
                      <h5 className="mb-0">Orko Arif</h5>
                      <span>Bizbite</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-sm-6 col-lg-6">
                <div className="testimonial-quote-wrap my-lg-3 my-md-3 rounded white-bg shadow-sm p-5">
                  <div className="client-say">
                    <p>
                      <img
                        src="img/quote.png"
                        alt="quote"
                        className="img-fluid"
                      />{" "}
                      Rapidiously develop user friendly growth strategies after
                      extensive initiatives. Conveniently grow innovative
                      benefits through fully tested deliverables. Rapidiously
                      utilize focused platforms through end-to-end schemas.
                    </p>
                  </div>
                  <div className="media author-info mb-3">
                    <div className="author-img mr-3">
                      <img
                        src="img/client-4.jpg"
                        alt="client"
                        className="img-fluid rounded-circle"
                      />
                    </div>
                    <div className="media-body">
                      <h5 className="mb-0">Rana Tabik</h5>
                      <span>Brinf LLC</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-sm-6 col-lg-6">
                <div className="testimonial-quote-wrap my-lg-3 my-md-3 rounded white-bg shadow-sm p-5">
                  <div className="client-say">
                    <p>
                      <img
                        src="img/quote.png"
                        alt="quote"
                        className="img-fluid"
                      />{" "}
                      Rapidiously develop user friendly growth strategies after
                      extensive initiatives. Conveniently grow innovative
                      benefits through fully tested deliverables. Rapidiously
                      utilize focused platforms through end-to-end schemas.
                    </p>
                  </div>
                  <div className="media author-info mb-3">
                    <div className="author-img mr-3">
                      <img
                        src="img/client-5.jpg"
                        alt="client"
                        className="img-fluid rounded-circle"
                      />
                    </div>
                    <div className="media-body">
                      <h5 className="mb-0">Rando Trump</h5>
                      <span>BizBite</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-sm-6 col-lg-6">
                <div className="testimonial-quote-wrap my-lg-3 my-md-3 rounded white-bg shadow-sm p-5">
                  <div className="client-say">
                    <p>
                      <img
                        src="img/quote.png"
                        alt="quote"
                        className="img-fluid"
                      />{" "}
                      Rapidiously develop user friendly growth strategies after
                      extensive initiatives. Conveniently grow innovative
                      benefits through fully tested deliverables. Rapidiously
                      utilize focused platforms through end-to-end schemas.
                    </p>
                  </div>
                  <div className="media author-info mb-3">
                    <div className="author-img mr-3">
                      <img
                        src="img/client-2.jpg"
                        alt="client"
                        className="img-fluid rounded-circle"
                      />
                    </div>
                    <div className="media-body">
                      <h5 className="mb-0">Jon Deoa</h5>
                      <span>BitBite</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Review;
